/**
 * HERO section 2 — marketing copy (H1 + sub + CTA) and the 19-button
 * feature-chip row that drives the interactive app-window below.
 *
 * 1:1 with the prototype (`Hausverwaltung Hero.dc.html`, lines 47–79). Each chip
 * switches the active module via `setActive`.
 */
import type { ReactNode } from "react";

import { useTranslations } from "next-intl";
import { HeroFeatureChipRow } from "../hero-feature-chip-row";
import { DarkButton } from "../hero-primitives";
import { HeroRotatorPhrase } from "../hero-rotator";
import { H } from "../hero-tokens";
import type { HeroModuleKey } from "../hero-types";

export function HeroIntro(props: {
  readonly active: HeroModuleKey;
  readonly setActive: (k: HeroModuleKey) => void;
}): ReactNode {
  const t = useTranslations("marketing.heroIntro");
  return (
    <div style={{ textAlign: "center", padding: "40px 28px 0" }}>
      <h1
        style={{
          fontFamily: H.display,
          fontWeight: 400,
          fontSize: "52px",
          lineHeight: 1.08,
          letterSpacing: "-0.016em",
          color: H.ink,
          margin: "0 auto",
          maxWidth: 1100,
        }}
      >
        {t.rich("kuendigeHeadline", {
          br: (): ReactNode => <br />,
          phrase: (): ReactNode => (
            <HeroRotatorPhrase
              style={{ display: "inline-block", whiteSpace: "nowrap" }}
            />
          ),
        })}
      </h1>

      <p
        style={{
          fontSize: "19px",
          lineHeight: 1.55,
          color: H.inkMute,
          margin: "20px auto 0",
          maxWidth: 640,
        }}
      >
        {t("allesSoftwareSchlussTausend")}
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 20,
          marginTop: 28,
        }}
      >
        <DarkButton href="/demo">
          {t("demoBuchen")} <span style={{ fontSize: "13px" }}>↗</span>
        </DarkButton>
      </div>

      <HeroFeatureChipRow active={props.active} setActive={props.setActive} />
    </div>
  );
}
